import { useMutation, useQueryClient } from '@tanstack/react-query';

import { isEmpty } from '@hsp/utilities';

import { sharedABQueryKeys } from 'pages/audience/shared/utilities';
import { externalListService } from 'services';
import { defaultResult, IExternalList } from 'types/api';

export const useExternalListMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      if (isEmpty(id)) {
        return defaultResult<IExternalList>();
      }

      return await externalListService.getExternalList(id);
    },
    onError: (_error, id, context) => {
      queryClient.setQueryData(sharedABQueryKeys.externalLists.byId(id), context);
    },
    onMutate: async (id: string) => {
      await queryClient.cancelQueries({ queryKey: sharedABQueryKeys.externalLists.byId(id) });
    },

    onSettled: (_data, _error, id) => {
      queryClient.invalidateQueries({ queryKey: sharedABQueryKeys.externalLists.byId(id) });
    },
  });
};
